<div class="item-title">{{editorTitle}}</div>
<textarea [froalaEditor]="options" [(froalaModel)]="content" class="froala-editor"></textarea>
<ng-template [ngIf]="isEdit || forceEdit">
  <div class="remaining-container">
    <span class="item-tag">Remaining: </span><span class="item-subtag">{{contentLengthRemaining}}</span>
  </div>
</ng-template>
